import store from '@app/store';

export function getIdVerificationStoreGetters() {
    return {
        user: store.getters['data/authentication/user'],
        kycVersion: store.getters['ui/multiStepVerification/isMultiStepIdVerification'],
    };
}
